// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import './common/js/rem.js'
import './common/css/reset.css'
import './common/css/flex.css'
import Api from './common/js/api'
import {post,get} from './common/js/http'
import Util from './common/js/util'
import Config from './common/js/config'
import Components from './common/js/components'

//import './common/js/wxAPi'
import wx from 'weixin-js-sdk'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Overlay } from 'vant';

Vue.use(Overlay);
Vue.use(Vant)
Vue.use(Components)
Vue.prototype.$api = Api
Vue.prototype.$post=post
Vue.prototype.$get=get
Vue.prototype.$util = Util
Vue.prototype.$config = Config
Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  let _url = window.location.origin + to.fullPath
  this.$post(this.$api.wxApi, {url:_url}).then((res) => {
    wx.config({
      debug:true, /// /生产环境需要关闭debug模式
      appId: res.data.appid, // appId通过微信服务号后台查看
      timestamp: res.data.timestamp, // 生成签名的时间戳
      nonceStr: res.data.noncestr, // 生成签名的随机字符串
      signature: res.data.signature, // 签名
      jsApiList: [// 需要调用的JS接口列表
        'onMenuShareTimeline', // 分享给好友
        'onMenuShareAppMessage'// 分享到朋友圈
      ]
    })
    wx.ready(function () {
      let shareData = {
        title: '商铺空置、租金低？找商旺宝，海量品牌租户免费配',	//	标题
        link: `${this.$config.webUrl}/20191129`,	//	分享的URL，必须和当前打开的网页的URL是一样的
        imgUrl: 'https://swb-bucket01.oss-cn-zhangjiakou.aliyuncs.com/swb/prod/leading/marketing/share1.png'//	缩略图地址
      }
      // 分享朋友圈
      wx.onMenuShareAppMessage(shareData)
      wx.onMenuShareTimeline(shareData)

      wx.error(function (res) {
        alert(res.errMsg)
      })
    })
  })
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js